// The background plugin
import background, { ModeEnum } from '@react-page/plugins-background';

// The divider plugin
import divider from '@react-page/plugins-divider';


// The html5-video plugin
import html5video from '@react-page/plugins-html5-video';


// The image plugin
import { imagePlugin } from '@react-page/plugins-image';

// carousel
import carousel from './carousel';

// accordion
import accordion from './accordion';

// The spacer plugin
import spacer from '@react-page/plugins-spacer';

// html
import html from './html';

// The video plugin
import YTvideo from '@react-page/plugins-video';


import { defaultSlate, customizedSlate } from './slate';

import quill from "../plugins/quill/index"

import block from "./block"
import iframe from "./iframe"
import pdf from "./pdf"
import video from "./video"
import {injectLayoutParams} from "../layout";

// Define which plugins we want to use.

export const cellPlugins = injectLayoutParams([
  {hideInMenu:true,id:"null"},
  //customizedSlate,
  defaultSlate,

  block,
  quill,
  spacer,
  imagePlugin(),
  carousel,
  accordion,
  YTvideo,
  divider,
  video,
  background(),
  pdf,
  iframe,
  html,
])
